import update from "immutability-helper";
import * as actionTypes from "application/redux/applicationActionTypes";

const initialState = {
  errorMessage: "",
};

const applicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ERROR_OCCURRED:
      return update(state, {
        errorMessage: { $set: action.error.message },
      });

    default:
      return state;
  }
};

export default applicationReducer;
